import React, { useState, useEffect } from 'react'
import {
    MDBCard, MDBContainer,
    MDBCol,
    MDBRow,
    MDBBtn,
    MDBIcon,
    MDBInput,
    MDBCheckbox,
    MDBTabs,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsContent,
    MDBTabsPane,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalFooter,
    MDBCardHeader,
    MDBCardBody,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody
} from 'mdb-react-ui-kit';
import ApplicationStages from './ApplicationStages';
import axios from 'axios'
import './Registration.css'
import newgif from '../assets/images/newGif.gif'
import Footer from './Footer';
import { useNavigate, useParams } from 'react-router-dom'
import ImpUpdate from './ImpUpdate';
import { API_BASE_URL, extractLoginToken, extractStudentInfo, setAuthSession } from '../utils/auth';


function Registration() {
    const userIds = useParams();
    console.log(userIds.id)
    const [fullscreenXlModal, setFullscreenXlModal] = useState(false);
    const [showAlert, setShowAlert] = React.useState(false);



    const [justifyActive, setJustifyActive] = useState('tab1');
    const navigate = useNavigate()
    // console.log(justifyActive)
    const handleJustifyClick = (value) => {
        if (value === justifyActive) {
            return;
        }

        setJustifyActive(value);
    };

    const [studentName, setStudentName] = useState('')
    const [country, setCountry] = useState('')
    const [gender, setGender] = useState('')
    const [mobileNo, setMobileNo] = useState('')
    const [emailId, setEmailId] = useState('')
    const [datareg, setDatareg] = useState({})
    const [enterEmailOtp, setEnterEmailOtp] = useState()
    const [enterMobileOtp, setEnterMobileOtp] = useState()
    const [studentUserId, setStudentUserId] = useState('')
    const [errorMessage, setErrorMessage] = useState('')



    /// login start
    const [applicationNo, setApplicationNo] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const [loginError, setLoginError] = useState('');

    const loginUser = async (e) => {
        e.preventDefault();
        setLoginError('');

        if (!applicationNo.trim() || !loginPassword.trim()) {
            setLoginError('Please enter Application No and Password.');
            return;
        }

        setIsLoggingIn(true);

        try {
            const response = await fetch(`${API_BASE_URL}/api/v1/front/user/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    applicationNo: applicationNo.trim(),
                    password: loginPassword,
                }),
            });
            const result = await response.json();
            const token = extractLoginToken(result);

            if (!response.ok || !token) {
                throw new Error(result.message || 'Login failed. Please check your credentials.');
            }

            setAuthSession(token, extractStudentInfo(result));
            navigate('/dashboard');
        } catch (error) {
            setLoginError(error.message || 'Unable to login. Please try again.');
        } finally {
            setIsLoggingIn(false);
        }
    };
    // login end

    const [makeydata, setMarkeyData] = useState([])
    console.log(makeydata)



    const markeyData = async () => {
        fetch('https://admin.aicee.in/counselling/markey-data')
            .then(response => response.json())
            .then(data => {
                setMarkeyData(data)


            })
            .catch(error => {
                console.log(error)
            })
    }
    useEffect(() => {
        markeyData()
    }, [])

    return (
        <div className='RegistrationCardContainer'>
            <div className='RegistrationCard'>
                <div className='RegistrationCard2'>
                    <MDBCard >
                        <div className='RegistrationCard3' style={{ backgroundColor: '#e35d26', padding: '15px', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ position: 'absolute', left: '20px', top: '50%', transform: 'translateY(-50%)' }} className="hidden md:block">
                                <img style={{ width: '60px', height: '60px' }} src='https://aicee.in/static/media/logo1.bdff491eff12e960f90c.png' alt="aicee" />
                            </div>
                            <div className='RegistrationCard5 text-center' style={{ color: 'white' }}>
                                <h1 style={{ fontSize: "32px", fontWeight: "bold", margin: 0, textTransform: 'uppercase' }}>AICEE 2026 COUNSELLING PORTAL</h1>
                                <div className='mt-1'>
                                    {
                                        makeydata.length >= 1 ? <>
                                            {
                                                makeydata.map((e, i) => {
                                                    return (
                                                        <marquee key={i} style={{ marginTop: '5px', color: 'white', fontWeight: '500', fontFamily: 'Open Sans, sans-serif' }}>
                                                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <a href={e.markeyUrl} target='_blank' rel="noreferrer" style={{ textDecoration: 'none', color: 'white' }}>{e.markeyName}</a>
                                                                <img style={{ marginLeft: '10px' }} src={newgif} alt="new" />
                                                            </span>
                                                        </marquee>
                                                    )
                                                })
                                            }
                                        </> : null
                                    }
                                </div>
                            </div>
                        </div>
                        <hr />
                        <MDBContainer fluid className="p-4 my-5">

                            <MDBRow style={{ marginTop: '-4.8rem' }}>

                                <MDBCol style={{ border: '1px solid #BDBDBD', borderRadius: '5px' }} col='6' md='5'>
                                    <MDBTabs style={{ backgroundColor: '#04124f', width: '100%', padding: '0px' }} className='mb-3 d-flex  '>
                                        {
                                            justifyActive == "tab2" ?
                                                <>
                                                    <MDBTabsItem style={{ listStyle: 'none' }}>
                                                        <MDBTabsLink style={{ fontSize: '0.9rem', fontWeight: 'bold', border: 'none', backgroundColor: 'white', color: '#17a2b8' }} onClick={() => handleJustifyClick('tab2')} active={justifyActive === 'tab2'}>
                                                            New User
                                                        </MDBTabsLink>
                                                    </MDBTabsItem>
                                                    <MDBTabsItem style={{ listStyle: 'none' }}>
                                                        <MDBTabsLink style={{ fontSize: '0.9rem', fontWeight: 'bold', border: 'none', color: 'white' }}
                                                            onClick={() => handleJustifyClick('tab1')} active={justifyActive === 'tab1'}>
                                                            Login
                                                        </MDBTabsLink>
                                                    </MDBTabsItem>
                                                </> :
                                                <>

                                                    {/* <MDBTabsItem style={{ listStyle: 'none', marginLeft: '1rem', marginTop: '5px', marginBottom: '5px' }}>
                                                        <MDBTabsLink style={{ fontSize: '0.9rem', fontWeight: 'bold', border: 'none', backgroundColor: 'white', color: '#17a2b8' }} onClick={() => handleJustifyClick('tab1')} active={justifyActive === 'tab1'}>
                                                            Login
                                                        </MDBTabsLink>
                                                    </MDBTabsItem> */}
                                                </>
                                        }
                                    </MDBTabs>
                                    <MDBTabsContent >

                                        <MDBTabsPane show={justifyActive === 'tab1'}>


                                            <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '20px', color: 'darkblue', marginBottom: '', padding: '10px', backgroundColor: 'white', borderRadius: '5px' }}> Counselling Portal Login <hr style={{ border: '2px solid darkblue', color: "darkblue", marginTop: '5px' }}></hr></div>

                                            <div className="mb-3">
                                                <label htmlFor="applicationNo" style={{ textAlign: 'start', fontWeight: 'bold', fontSize: '1rem', color: 'black', fontFamily: 'Open Sans, sans-serif' }}>
                                                    <MDBIcon fas icon="user" className="me-2" /> Application No<span style={{ color: "#f90000", fontWeight: 'bolder' }}>*</span>
                                                </label>
                                                <MDBInput
                                                    onChange={(e) => { setApplicationNo(e.target.value) }}
                                                    value={applicationNo}
                                                    autoComplete="off"
                                                    wrapperClass='mb-2'
                                                    id='applicationNo'
                                                    type='text'
                                                    placeholder="Enter Application No"
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label htmlFor="password" style={{ textAlign: 'start', fontWeight: 'bold', fontSize: '1rem', color: 'black', fontFamily: 'Open Sans, sans-serif' }}>
                                                    <MDBIcon fas icon="key" className="me-2" /> Password<span style={{ color: "#f90000", fontWeight: 'bolder' }}>*</span>
                                                </label>
                                                <div className="position-relative">
                                                    <MDBInput
                                                        onChange={(e) => { setLoginPassword(e.target.value) }}
                                                        value={loginPassword}
                                                        autoComplete="off"
                                                        wrapperClass='mb-0'
                                                        id='password'
                                                        type={showPassword ? 'text' : 'password'}
                                                        placeholder="Enter Password"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        className="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent pe-3"
                                                        style={{ zIndex: 10, marginTop: '-5px' }}
                                                    >
                                                        <MDBIcon fas icon={showPassword ? 'eye-slash' : 'eye'} className="text-muted" />
                                                    </button>
                                                </div>
                                            </div>

                                            {loginError && (
                                                <p className="text-danger small fw-bold mb-3">{loginError}</p>
                                            )}

                                            <button
                                                style={{ backgroundColor: '#04124f', marginTop: '0.5rem', color: 'white', fontWeight: 'bold', padding: '10px 0', borderRadius: '8px' }}
                                                onClick={loginUser}
                                                // onClick={() => { alert(`Counselling portal login is currently not active for students due to a technical Glitch, we are resolving this issue , please be patient.`) }}
                                                disabled={isLoggingIn}
                                                className="mb-4 w-100 border-0"
                                            >
                                                {isLoggingIn ? 'Logging in...' : 'Login'}
                                            </button>
                                        </MDBTabsPane>
                                    </MDBTabsContent>

                                </MDBCol>

                                <MDBCol col='6' md='7'>

                                    <ApplicationStages />



                                </MDBCol>

                            </MDBRow>

                            <div style={{ marginTop: '15px' }}><ImpUpdate /></div>
                        </MDBContainer>
                        <div className=''>
                        </div>
                        <div style={{ margin: '0 0 -4rem 0' }}></div>
                    </MDBCard>
                </div>
            </div>
            <div><Footer /></div>
        </div>
    )
}

export default Registration
